import remove from 'lodash/fp/remove'
import orderBy from 'lodash/fp/orderBy'
import { IUploadedImageAsset } from '@api/types'

export const createRemoveById = (id: string) => remove<IUploadedImageAsset>({ id })

export const orderByDate = orderBy<IUploadedImageAsset>('updatedAt', 'desc')
